export class GetPackageDetailsRequest {
  cityCode: string;
  checkIn: string;
  name: string;
  paxComplect: string;
  dealId: string;
  rowId: string;
  hotelId: string;
  type: number;
  selectedRooms?: string[];
  infants?: number;
  flightIndex?: number;
  paxes?: number;
  orderId?: number;
  provider: string;
  isSale: boolean;
  searchToken?: string;
  nights?: string;
  discountId?: number;
  selectedInfantInRooms?: string[];

  constructor(details: any) {
    this.cityCode = details.cityCode;
    this.checkIn = details.checkIn;
    this.name = details.name;
    this.paxComplect = details.paxComplect;
    this.dealId = details.dealId;
    this.rowId = details.rowId;
    this.hotelId = details.hotelId;
    this.type = +details.type;
    this.selectedRooms = details.selectedRooms;
    this.infants = details.infants;
    this.flightIndex = details.flightIndex;
    this.paxes = details.paxes;
    this.orderId = details.orderId;
    this.provider = details.provider;
    this.isSale = details.isSale?.toLowerCase() === 'true';
    this.searchToken = details.searchToken;
    this.discountId = +details.discountId;
    this.selectedInfantInRooms = details.selectedInfantInRooms;
  }
}
